// extracted by mini-css-extract-plugin
module.exports = {"layout":"CheckoutFormModalitaConsegna_layout__WRv6O","rotation":"CheckoutFormModalitaConsegna_rotation__ejDjM"};